<template>
  <div class="CanvasOmniBlockGrouping">
    poop
    <!-- <CanvasOmniBlock

         v-for="(model, modelindex) in OmniBlocksInput.CanvasGroups"
         :yoffset="OmniBlocksInput.subys[modelindex]"
         :zoffset="5"
         :scenarioset="scenarioIn"
         :headerOnly="true"
         :parentx="parentx"
         :blocks="CGsforCanvasOmniBlock(model)"
         :timelinezoomlevel="timelinezoomlevel"
    >

    </CanvasOmniBlock> -->

  </div>


</template>

<style>
.CanvasOmniBlockGrouping {
  background-color: red;
  color: white;
}


</style>
<script>

import CanvasOmniBlock from '@/components/Canvas/Canvas-Omni-Block.vue'

export default {
  name: 'CanvasOmniBlockGrouping',
  components: {
    CanvasOmniBlock
  },
  props: {
    OmniBlocksInput: {

    },
    scenarioIn: {

    },
    timelinezoomlevel: {

    },
    parentx: {

    }

  },
  data: function () {
    return {

    }
  },

  methods: {
    CGsforCanvasOmniBlock(cg){

      var clone=JSON.parse(JSON.stringify(this.$store.state.CanvasGroups))
      var index0 = clone.findIndex((v) => {
        return v.id==cg;
      });

      return clone[index0]

    }
  },

  computed: {
    cgsForDisplay () {

      //top is the start of the first block
      //height is the calculated below as a result of the # of CGBs

      var clone=JSON.parse(JSON.stringify(this.$store.state.CanvasGroups))
      var canvasGroupsReturn = [];

      for(let ob = 0; ob < OmniBlocksInput.CanvasGroups.length; ob++){

        var index0 = clone.findIndex((v) => {

          return v.id==OmniBlocksInput.CanvasGroups[ob];

        });

      var tempOb = clone[index0]

        if(this.$store.state.allGroups){
          //need to go through all group pairs and push to display array

          for(let n=0; n<4; n++){


            canvasGroupsReturn.push(tempOb)


          }

        }else{
          //just push signle CG to display array
          canvasGroupsReturn.push(tempOb)
        }


      }

      return canvasGroupsReturn

    }

  }

}
</script>
